import { produce } from 'immer';
import { api } from '../../api';
import { sessionStore, SessionStore, SessionState } from './SessionStore';
import { AbstractFacade } from '../../shared';
import { notification } from 'antd';

export class SessionFacade extends AbstractFacade {
  constructor(readonly store: SessionStore) {
    super(store);
  }

  login = (user: string, password: string) =>
    this.doRequest(async () => {
      const res = await api.auth.login(user, password);

      if (res.response) {
        this.store.update((state) => {
          state.isLoggedIn = true;
        });
      } else {
        this.store.setError({ message: 'Incorrect username or password.' });
      }
    });

  restorePassword = (email: string) =>
    this.doRequest(async () => await api.auth.restorePassword(email));

  changePassword = (oldPassword: string, newPassword: string) =>
    this.doRequest(async () => {
      const res = await api.auth.changePassword(oldPassword, newPassword);
      let type: 'success' | 'error', message: string;

      if (res.response) {
        type = 'success';
        message = 'Password updated.';
      } else {
        type = 'error';
        message = 'Update failed, please, try again later.';
      }

      notification[type]({ message });

      return res;
    });

  logout = async () => {
    await api.auth.logout();

    this.store.update(
      produce((state: SessionState) => {
        state.isLoggedIn = false;
      })
    );
  };

  setLoggedIn = (isLoggedIn: boolean) => {
    this.store.update((state) => {
      state.isLoggedIn = isLoggedIn;
    });
  };

  clearError = () => {
    this.store.setError(null);
  };
}

export const facade = new SessionFacade(sessionStore);
